import { a } from './chunk-XCSSTYD2.mjs';
import { create } from 'zustand';

var l=create((e,t)=>({...a(e,t),show({characterId:i}){e({characterId:i,isActive:!0});}}));

export { l as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-UNX6ZRQH.mjs.map